import { render, staticRenderFns } from "./BCXFilterButtons.vue?vue&type=template&id=98d2db52&scoped=true"
import script from "./BCXFilterButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXFilterButtons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXFilterButtons.vue?vue&type=style&index=0&id=98d2db52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d2db52",
  null
  
)

export default component.exports